import getValues from "backend/values";
import isDraftFilterAtLocation from "qpr-base/attributes/drafts/disabledPages";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

import { useQuery } from "react-query";
import usePeriodFromString from "../model/usePeriodFromString";
import usePeriodLevels from "../model/usePeriodLevels";

const useElement = (id?: string, period?: string) => {
  const ctx = useAppContext();
  const currentPeriod = usePeriodFromString(period);
  const { data: periodLevels } = usePeriodLevels();
  return useQuery(
    `data-element-useElement-${id || ctx.elementId}-${
      currentPeriod?.name || ""
    }-${isDraftFilterAtLocation()}`,
    () => {
      return getValues(
        id || ctx.elementId || "",
        currentPeriod ? [currentPeriod] : [],
        true,
        periodLevels!
      ).then((list) => {
        return list[0];
      });
    },
    {
      enabled: !!currentPeriod && !!periodLevels && !!id,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useElement;
